export default
'<?xml version="1.0" encoding="UTF-8"?>' +
'<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 640 640">' +
'<g>' +
'<path d="M478.3,203.2c-17.5,0-31.7,28.4-31.7,63.3s14.1,63.3,31.7,63.3,31.7-28.4,31.7-63.3-14.1-63.3-31.7-63.3Z"/>' +
'<path d="M580.9,114.5c-11.1-22.3-24.6-40.2-40-53.2-18.8-15.9-40.4-24.3-62.5-24.3s-4.2,0-6.3.2l.2-.2H161.7c-22.1,0-43.7,8.4-62.5,24.3-15.4,13.1-28.9,31-40,53.2-20.6,41.3-32,95.3-32,152v200.2c0,52.4,42.6,95,95,95h158.3c52.4,0,95-42.6,95-95v-48.9c.1.2.2.5.3.7,11.1,22.3,24.6,40.2,40,53.2,18.8,15.9,40.4,24.3,62.5,24.3s43.7-8.4,62.5-24.3c15.4-13.1,28.9-31,40-53.2,20.6-41.3,32-95.3,32-152s-11.4-110.7-32-152ZM368.7,111c-21.2,42.2-32.8,97.4-32.8,155.5v200.2c0,30.6-24.8,55.4-55.4,55.4H122.1c-30.6,0-55.4-24.8-55.4-55.4v-200.2c0-104.9,42.5-190,95-190h228.6c-8.7,11-15.8,22.9-21.7,34.4ZM478.3,456.5c-52.4,0-95-85.1-95-190s42.5-190,95-190,95,85.1,95,190-42.5,190-95,190Z"/>' +
'</g>' +
'<g>' +
'<rect x="108" y="216.8" width="188" height="26"/>' +
'<rect x="108" y="286.1" width="188" height="36"/>' +
'<rect x="108" y="351" width="188" height="7.7"/>' +
'<rect x="108" y="365.5" width="188" height="9.4"/>' +
'<rect x="108" y="423.8" width="188" height="28.1"/>' +
'<rect x="108" y="251.7" width="188" height="12.1"/>' +
'<rect x="108" y="388" width="188" height="10.8"/>' +
'<rect x="108" y="459.9" width="188" height="14.2"/>' +
'</g>' +
'</svg>';
